<template>
  <transition name="Particles">
    <div class="Particles">
      <canvas ref="canvas"></canvas>
    </div>
  </transition>
</template>

<script>
import Proton from 'proton-js'

export default {
  name: 'Particles',
  beforeDestroy() {
    this.$renderer.gl.getExtension('WEBGL_lose_context').loseContext()
    this.$proton.destroy()
    window.removeEventListener('resize', this.onResize)
    this.untick()
  },
  activated() {
    const gl = this.$renderer.gl
    gl.clear(gl.DEPTH_BUFFER_BIT | gl.COLOR_BUFFER_BIT);
    this.tick()
    this.$emitter.emit(.75)
  },
  deactivated() {
    this.$emitter.removeAllParticles()
    this.untick()
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
    const canvas = this.$refs.canvas
          canvas.width = window.innerWidth
          canvas.height = window.innerHeight

    this.$canvas = canvas
    this.$proton = new Proton
    this.createEmitter()
    this.$proton.addEmitter(this.$emitter)
    this.$renderer = new Proton.WebGLRenderer(canvas)
    this.$renderer.blendFunc("SRC_ALPHA", "ONE")
    this.$proton.addRenderer(this.$renderer)
  },
  methods: {
    createEmitter() {
      const emitter = new Proton.Emitter()
      this.$crossZoneBehaviour = new Proton.CrossZone(new Proton.RectZone(0, 0, this.$refs.canvas.width, this.$refs.canvas.height), 'cross')
      emitter.rate = new Proton.Rate(new Proton.Span(15, 80), new Proton.Span(.05, .12))
      emitter.addInitialize(new Proton.Mass(1))
      emitter.addInitialize(new Proton.Life(10, 0.5))
      emitter.addInitialize(new Proton.Body([require('./images/particle.png'), require('./images/star.png')]))
      emitter.addInitialize(new Proton.Radius(0.4, 5))
      emitter.addInitialize(new Proton.Velocity(new Proton.Span(1, 10), new Proton.Span(0, 360), 'polar'))
      emitter.addBehaviour(new Proton.Scale(Proton.getSpan(0.1, 1.2), 0))
      emitter.addBehaviour(this.$crossZoneBehaviour, new Proton.Color('#138EBF', '#DBDB16'))
      emitter.p.x = this.$refs.canvas.width / 2
      emitter.p.y = this.$refs.canvas.height / 2
      emitter.rotation = 0
      this.$emitter = emitter
    },
    tick() {
      this.$rafID = requestAnimationFrame(this.tick)
      this.$proton.update()
    },
    untick() {
      if(this.$rafID)
        cancelAnimationFrame(this.$rafID)
    },
    onResize() {
      this.$canvas.width = window.innerWidth
      this.$canvas.height = window.innerHeight
      this.$crossZoneBehaviour.reset(new Proton.RectZone(0, 0, this.$canvas.width, this.$canvas.height), 'cross')
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Particles
  position fixed
  top 0px
  left 0px
  right 0px
  bottom 0px
  transition opacity 1s
  &-enter
  &-leave-active
    opacity 0
    opacity 0

  canvas
    position absolute
    width 100%
    height 100%
</style>



// WEBPACK FOOTER //
// src/components/particles/Particles.vue